import axios from 'axios'
import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { CreatePlpType } from 'Pages/Frontend/Interface/Plp/CreatePlp/CreatePlp'
import { plpUpdateType } from 'Models/plpUpdataType'
import { PoolTab } from 'BlockchainAdmin/Pages/Frontend/Interface/Admin/PoolState/PoolState'
AxiosInterceptor()

const plpService = {
  async index(
    pageNumber: number,
    sortOrder: string,
    status: string,
    isSuspended?: boolean | undefined,
    version?: string | undefined,
    tab?: PoolTab,
  ) {
    const formVersion = version === undefined ? '' : `&formVersion=${version}`
    const formIsSuspended = isSuspended === undefined ? '' : `&isSuspended=${isSuspended}`
    const formAddedToBlockchain = tab === 'unassigned' ? '' : `&addedToBlockchain=${true}`
    const notaddedBlockchain = tab === 'assigned' ? '' : `&notAddedToBlockchain=${true}`

    return await axios.get(
      `/plpApplications?pageNumber=${pageNumber}&sortOrder=${sortOrder}&status=${status}${formVersion}${formIsSuspended}${formAddedToBlockchain}${notaddedBlockchain}`,
    )
  },

  async productLease(
    pageNumber: number,
    sortOrder = 'ASC',
    accountId?: number,
    customerMsisdn?: string,
    orderReference?: string,
    isActive?: boolean,
    isFullyPaid?: boolean,
    autoPaymentEnabled?: boolean,
    paymentDueBefore?: number,
    paymentDueAfter?: number,
  ) {
    const params = new URLSearchParams()
    params.append('pageNumber', pageNumber.toString())
    params.append('sortOrder', sortOrder)
    if (accountId) params.append('accountId', accountId.toString())
    if (customerMsisdn) params.append('customerMsisdn', customerMsisdn)
    if (orderReference) params.append('orderReference', orderReference)
    if (isActive !== undefined) params.append('isActive', isActive.toString())
    if (isFullyPaid !== undefined) params.append('isFullyPaid', isFullyPaid.toString())
    if (autoPaymentEnabled !== undefined)
      params.append('autoPaymentEnabled', autoPaymentEnabled.toString())
    if (paymentDueBefore !== undefined)
      params.append('paymentDueBefore', paymentDueBefore.toString())
    if (paymentDueAfter !== undefined) params.append('paymentDueAfter', paymentDueAfter.toString())

    return await axios.get(`/product-leases?${params.toString()}`)
  },

  async exportPLP(sortOrder: string, status: string | undefined) {
    if (status && status !== 'ALL') {
      return await axios.get(`/plpApplications/export/csv?sortOrder=${sortOrder}&status=${status}`)
    } else {
      return axios.get(`/plpApplications/export/csv?sortOrder=${sortOrder}`)
    }
  },

  async getDetails(referenceId: string | undefined) {
    return axios.get(`/plpApplications/${referenceId}`)
  },

  async aproval(
    referenceId: string | undefined,
    aproval: string,
    rejectionReason?: string | undefined,
  ) {
    return axios.put(`/plpApplications/${referenceId}/approveOrReject/${aproval}`, {
      rejectionReason,
    })
  },

  async approveDocument(id: string | undefined, documentName: string | undefined) {
    return axios.post(`/plpApplications/${id}/approveDocument`, {
      documentName,
    })
  },

  async rejectDocument(
    id: string | undefined,
    rejectionReason: string,
    documentName: string | undefined,
  ) {
    return axios.post(`/plpApplications/${id}/rejectDocument`, {
      rejectionReason,
      documentName,
    })
  },

  async toggleSuspension(referenceId: string | undefined) {
    return axios.put(`/plpApplications/${referenceId}/toggleSuspension`)
  },

  async create(data: CreatePlpType) {
    return axios.post('/plpApplications', data)
  },

  file: async (plpUuid: string | undefined, data: FormData, fileUploadCategory: string) => {
    console.log('Traders Card SERVICE DATA', { plpUuid, file: data, name: fileUploadCategory })

    return await axios.put(
      `/plpApplications/${plpUuid}/fileUpload?fileUploadCategory=${fileUploadCategory}`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )
  },

  leaseFileUpload: async (plpUuid: string | undefined, data: FormData) => {
    return await axios.put(`/plpApplications/${plpUuid}/station-lease-documents/fileUpload`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  async unassignStation(id: string) {
    return await axios.put(`/plpApplications/${id}/unassignFromStationLeaseAsset`)
  },
  async assignStation(id: string, stationLeaseAssetId: string) {
    return await axios.put(
      `/plpApplications/${id}/assignToStationLeaseAsset/${stationLeaseAssetId}`,
    )
  },

  async cardApproval(referenceId: string | undefined, valuation: number) {
    return axios.post(`/plpApplications/${referenceId}/approveTradersCard`, { valuation })
  },

  async cardRejectDocument(
    referenceId: string | undefined,
    rejectionReason: string,
    documentName: string,
  ) {
    return axios.post(`/plpApplications/${referenceId}/rejectDocument`, {
      rejectionReason,
      documentName,
    })
  },

  async updatePLP(id: string | undefined, data: plpUpdateType) {
    return axios.put(`/plpApplications/${id}`, data)
  },

  async addToPool(id: string) {
    return await axios.post(`/plpApplications/${id}/addToPool`)
  },

  async removeFromPool(id: string) {
    return await axios.post(`/plpApplications/${id}/removeFromPool`)
  },
}
export default plpService
